// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2YIZ-","right":"styles_right__2nMYI"};